/*
 * @Author: your name
 * @Date: 2020-06-11 16:24:48
 * @LastEditTime: 2020-06-23 10:43:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \client-v4\src\i18n\lang\it.js
 */
module.exports = {
    buyRegister: {
        mainName: 'Please enter your last name',//姓
        firstName: 'Please enter your first name',//名
        email: 'Please enter your email address.',//邮箱
        confemail: 'Please confirm your email address.',//确认邮箱
        iphone: 'Please enter your cell number.',//电话号码
        num: 'Please enter your phone number.',//座机号码
        pwd: 'Please enter a password.',//电话号码
        confpwd: 'Please confirm your password.',//密码
        errorEmail: 'Please check your email.',//输入一样的密码
        errorPwd: 'Please check your password.',//输入一样的密码
        emailType: 'Please check your email format',//输入一样的邮箱地址
        pwdType: 'Please check your password format',//密码格式不正确
        webSite: 'Please enter your website address',//网站地址
        confwebSite: 'Please check your website format',//网站地址不正确
        country: 'Please select your country',//国家
        intra: 'Please enter your business VAT number',//税号

        word1: 'Please enter a street number',//街道号码
        word2: 'Please enter an address',//地址
        word3: 'Please enter a city.',//城市
        word4: 'Please enter a phone number.',//电话号码
        word5: 'Please enter a contact name',//联系人姓
        word6: 'Please enter a postal code',//邮编
        word7: 'Please enter a street number',//请输入街道号码
        word8: 'Please enter the street name.',//请输入地址
        word9: 'Please enter a city.',//请输入城市
        word10: 'Please enter a phone number.',//请输入联系电话
        word11: 'Please enter a contact name',//请输入联系人姓
        word12: 'Please enter a postal code',//请输入邮编
        word13: 'Please enter a contact name',//请输入姓
        word14: 'Please select a default language',//请选择默认语言
        word15: 'Please select your area of activity.',//请选择经营范围
        word16: 'Please accept the terms of use and privacy policy.',//请同意使用条款
        word17: 'english address must input eori.',//英国地址必须填写eori号码
    },
    sellRegister: {
        sell1: 'Please enter your company name',//请输入企业名称
        sell2: 'Please enter your last name',//请输入商家姓
        sell3: 'Please enter your first name',//请输入商家名
        sell4: 'Please enter your business VAT number',//请输入税号
        sell5: 'Please enter the store name',//请输入店铺名称
        sell6: 'This email address is already in use',//您的邮箱地址已注册
        sell7: 'Please enter a street number',//请输入街道号码
        sell8: 'Please enter a city',//请输入商家城市
        sell9: 'Please enter a city',//请输入商家城市
        sell10: 'Please enter the street name',//请输入地址
        sell11: 'Please enter a postal code',//请输入邮编
        sell12: 'Please upload a proof of business',//请输入税号
        sell13: 'Please enter the merchant bank number',//请输入商家银行号
        sell14: "Please enter the merchant's bank information",//请输入商家银行信息
        sell15: "Please upload the manager's ID",//请上传商家身份证件
        sell16: 'Please enter your brand(s)',//请添加商家品牌
        sell17: 'Please enter your categories',//请选择商家产品目录
        sell18: 'Please enter the desired minimum order amount',//请填写最低订单要求
        sell19: 'Please enter a number',//请输入有效数字
        sell20: 'Please select your field of activity'//请选择商家营业范围
    },
    account: {
        word1: "disconnect",//登出
        word2: "The email address must not be empty", //email地址不能为空
        word3: "The two emails are different",//两个邮箱地址不一致
        word4: "Subscribe to efashion paris newsletter",//是否订阅邮件
        word5: "I agree to receive notifications on the application",//是否接收手机应用的同志
        word6: "I agree to receive sms",//是否接收订单更新的短信通知
    },
    seller_marques: {
        word1: "the brand has been added to favorites.",//添加收藏成功 商家
        word2: "the brand has been removed from favorites.",//取消收藏成功 商家
        word3: "Please login to execute this action.",//请先登录 再进行这个操作
    },
    product_detail: {
        word1: "The product has been added to your cart",//产品已经添加到购物车
        word2: "The minimum order quantity is ",//最低订购数量为
        word3: "Colors",//颜色
        word4: "Packs",//包
        word5: "Quantity",//数量
        word6: "Total",//总数
        word7: "Incorrect purchase quantity or amount",//购买数量或者金额有误
    },
    goods_list: {
        couleurs: 'colors',
        melangees: 'Mixed colors',
        tailles: 'Choose sizes',
    },
    favor_articles: {
        word1: "Add to favorite successfully",//添加收藏成功
        word2: "Cancel the favorite successfully",//取消收藏成功
        word3: "operation failed,please try again",//收藏操作失败
    },
    common: {
        yes: 'Yes',//是
        no: 'No'//否
    },
    moncompte_articles: {
        word1: 'One or more items have defects ',
        word2: 'Missing item(s)',
        word3: 'I received one or more items that do not match my order',
        word4: 'Hello, I have "number of damaged items" in my order, you will find attached the photos for proof (download the photos). Please help me with my request.',
        word5: 'Hello, I just received my order but some items are missing: "complete by buyer". Please inform the supplier and reach back to me',
        word6: 'Hello, I just received my order and "detail the problem precisely, wrong reference, color, size". Please inform the supplier and reach back to me.',
        word7: 'other',
    },
    topMenuDesc: {
        'Accessoires': 'Accessories',
        'Marques': 'Brands',
        'Nouveautés': 'News',
        'Outlet': 'Outlet',
        'Vêtements': 'Clothes',
        'decouvrir': 'Discover',
        "AJOURD HUI": "NEW TODAY",
        'CETTE SEMAINE': 'NEW THIS WEEK',
        'NOUVEAUX VENDEURS': 'NEW SELLER',
        'Nouveautés Vêtements': 'New Clothing',
        'Nouveautés Accessoires': 'New Accessories',
        'Tendances': 'Trends',
    },
    topMenuOutlet: {
        word1: 'Buy at the price',
        word2: "Greater than 5 euro",
        word3: "5 euros to 10 euro ",
        word4: "10 euros to 15 euro",
        word5: 'Buy at a discount',
        word6: "0 to 30%",
        word7: 'From 30% to 50%',
        word8: 'More than 50%',
        word9: "The promotion code",
        word10: "At a discount",
        word11: "All promotional",
        word12: "Coat on sale",
        word13: "Promotional dresses and jumpsuits",
        word14: "Shoes are on sale",
        word15: "Leather goods on sale",
        word16: "Big yard sales",
        word17: "less",
        word18: "5€",
        word19: "Less than 5€ ",
    },
    topMenuNoLogin: {
        'preview catalog': 'preview catalog',
    },
    chooseCarte: {
        word1: 'eori can not empty',
        word2: 'english need eori,please add eori at address modify',
    },
    homeLogin: {
        word1: 'copy',
    }
}
